export default __webpack_public_path__ + "static/media/bn-doctor.cba93cf8.png";